import accesslogs from "@/api/accesslogs";

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    async accessLogs(context, { menu, ope }) {
      try {
        const params = {
          account_id: await context.dispatch("showAccountID"),
          user_id: await context.dispatch("showUserId"),
          menu: menu,
          ope: ope
        }
        await accesslogs.insert(params);
      } catch (error) {
        console.log(error);
      }
    },
  }
};
